import Vue from 'vue';
import VueLazyLoad from 'vue-lazyload';

Vue.use(VueLazyLoad, {
	preLoad: 1.3,
	attempt: 1,
});
